module.exports = __webpack_public_path__ + "static/media/informationIcon.4d4a6b24.svg";